import React from 'react';
import { cx } from './utils';

export default function SectionHeader({ title, subtitle, right, className }) {
  return (
    <div className={cx('sectionHeader', className)}>
      <div>
        <h1 className="sectionHeader__title">{title}</h1>
        {subtitle && <div className="sectionHeader__subtitle">{subtitle}</div>}
      </div>
      {right ? <div className="sectionHeader__right">{right}</div> : null}
    </div>
  );
}
